import { useState } from 'react';
import { faListMusic } from '@fortawesome/pro-regular-svg-icons';
import { FontAwesomeIcon } from '@fortawesome/react-fontawesome';
import {
  ButtonWithTooltip,
  insertDirective$,
  usePublisher,
} from '@mdxeditor/editor';
import { useTranslation } from 'react-i18next';

import type { IWPPlaylistMdxDirectiveDialogFormValues } from './WPPlaylistMdxDirectiveDialogForm';
import { WP_PLAYLIST_MDX_DIRECTIVE_NAME } from './wpPlaylistMdxDirectiveConstants';
import { WPPlaylistMdxDirectiveDialogForm } from './WPPlaylistMdxDirectiveDialogForm';

export type IWPPlaylistMdxDirectiveToolbarButtonProps = {
  appId: string;
};

export type IWPPlaylistMdxDirectiveAttributes = {
  url: string;
};

export const WPPlaylistMdxDirectiveToolbarButton: React.FC<
  IWPPlaylistMdxDirectiveToolbarButtonProps
> = (props) => {
  const { appId } = props;
  const insertDirective = usePublisher(insertDirective$);
  const [opened, setOpened] = useState(false);
  const { t } = useTranslation();

  const handleSubmit = (
    values: IWPPlaylistMdxDirectiveDialogFormValues,
  ): void => {
    setOpened(false);
    const attributes: IWPPlaylistMdxDirectiveAttributes = {
      url: values.url ?? '',
    };

    insertDirective({
      name: WP_PLAYLIST_MDX_DIRECTIVE_NAME,
      type: 'leafDirective',
      attributes,
    });
  };

  return (
    <>
      <WPPlaylistMdxDirectiveDialogForm
        appId={appId}
        opened={opened}
        onClose={() => setOpened(false)}
        onSubmit={handleSubmit}
      />

      <ButtonWithTooltip
        title={t('WPPlaylistMdxDirectiveToolbarButton.tooltip')}
        onClick={() => setOpened(true)}
      >
        <FontAwesomeIcon
          icon={faListMusic}
          fontSize={18}
          style={{ padding: 3 }}
        />
      </ButtonWithTooltip>
    </>
  );
};
